"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftCompensationSettingsT = exports.DriftCompensationSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Settings related to IMU yaw drift compensation
 */
class DriftCompensationSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsDriftCompensationSettings(bb, obj) {
        return (obj || new DriftCompensationSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsDriftCompensationSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new DriftCompensationSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    enabled() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    prediction() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    /**
     * 0 to 1. A higher value results in more yaw drift compensation
     */
    amount() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    /**
     * Number of previous resets to take into account when calculating yaw drift
     */
    maxResets() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    static startDriftCompensationSettings(builder) {
        builder.startObject(4);
    }
    static addEnabled(builder, enabled) {
        builder.addFieldInt8(0, +enabled, +false);
    }
    static addPrediction(builder, prediction) {
        builder.addFieldInt8(1, +prediction, +false);
    }
    static addAmount(builder, amount) {
        builder.addFieldFloat32(2, amount, 0.0);
    }
    static addMaxResets(builder, maxResets) {
        builder.addFieldInt16(3, maxResets, 0);
    }
    static endDriftCompensationSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createDriftCompensationSettings(builder, enabled, prediction, amount, maxResets) {
        DriftCompensationSettings.startDriftCompensationSettings(builder);
        DriftCompensationSettings.addEnabled(builder, enabled);
        DriftCompensationSettings.addPrediction(builder, prediction);
        DriftCompensationSettings.addAmount(builder, amount);
        DriftCompensationSettings.addMaxResets(builder, maxResets);
        return DriftCompensationSettings.endDriftCompensationSettings(builder);
    }
    unpack() {
        return new DriftCompensationSettingsT(this.enabled(), this.prediction(), this.amount(), this.maxResets());
    }
    unpackTo(_o) {
        _o.enabled = this.enabled();
        _o.prediction = this.prediction();
        _o.amount = this.amount();
        _o.maxResets = this.maxResets();
    }
}
exports.DriftCompensationSettings = DriftCompensationSettings;
class DriftCompensationSettingsT {
    constructor(enabled = false, prediction = false, amount = 0.0, maxResets = 0) {
        this.enabled = enabled;
        this.prediction = prediction;
        this.amount = amount;
        this.maxResets = maxResets;
    }
    pack(builder) {
        return DriftCompensationSettings.createDriftCompensationSettings(builder, this.enabled, this.prediction, this.amount, this.maxResets);
    }
}
exports.DriftCompensationSettingsT = DriftCompensationSettingsT;
